<div class="prospecting-nav">
    <div class="nav-tabs">
        <a routerLink="/admin/prospecting/map" routerLinkActive="active" class="nav-tab">
            <i class="fa-solid fa-map-location-dot"></i> Map
        </a>
        <a routerLink="/admin/prospecting/board" routerLinkActive="active" class="nav-tab">
            <i class="fa-solid fa-table-columns"></i> Board
        </a>
        <a routerLink="/admin/prospecting/table" routerLinkActive="active" class="nav-tab">
            <i class="fa-solid fa-table"></i> Table
        </a>
        <a routerLink="/admin/prospecting/timeline" routerLinkActive="active" class="nav-tab">
            <i class="fa-solid fa-clock-rotate-left"></i> Timeline
        </a>
        <a routerLink="/admin/prospecting/scraper" routerLinkActive="active" class="nav-tab">
            <i class="fa-solid fa-magnifying-glass-location"></i> Scraper
        </a>
        <a routerLink="/admin/prospecting/assistant" routerLinkActive="active" class="nav-tab">
            <i class="fa-solid fa-robot"></i> Assistant
        </a>
        <a routerLink="/admin/prospecting/settings" routerLinkActive="active" class="nav-tab">
            <i class="fa-solid fa-gear"></i> Settings
        </a>
    </div>
    <button class="new-company-btn" (click)="toggleNewCompany()">
        <i class="fa-solid fa-plus"></i> New Company
    </button>
</div>

<!-- New Company form (inline) -->
<div class="new-company-overlay" *ngIf="showNewCompany" (click)="showNewCompany = false">
    <div class="new-company-modal" (click)="$event.stopPropagation()">
        <div class="new-company-header">
            <h2><i class="fa-solid fa-building"></i> Add New Company</h2>
            <button type="button" class="close-btn" (click)="showNewCompany = false"><i class="fa-solid fa-xmark"></i></button>
        </div>
        <div class="new-company-body">
            <label class="field-label">Company Name *</label>
            <input type="text" [(ngModel)]="newCompany.name" placeholder="Company name" />

            <label class="field-label">Address</label>
            <input
                #addressInput
                type="text"
                [value]="newCompany.fullAddress || ''"
                (input)="newCompany.fullAddress = $any($event.target).value"
                placeholder="Start typing an address..."
            />
            <p class="geocode-hint" *ngIf="newCompany.latitude && newCompany.longitude">
                <i class="fa-solid fa-map-pin"></i> {{ newCompany.latitude | number: '1.4-4' }}, {{ newCompany.longitude | number: '1.4-4' }}
            </p>

            <div class="field-row">
                <div>
                    <label class="field-label">Website</label>
                    <input type="text" [(ngModel)]="newCompany.website" placeholder="https://..." />
                </div>
                <div>
                    <label class="field-label">Phone</label>
                    <input type="text" [(ngModel)]="newCompany.phone" placeholder="Phone number" />
                </div>
            </div>

            <label class="field-label">Notes</label>
            <textarea [(ngModel)]="newCompany.notes" rows="3" placeholder="Any notes about this company"></textarea>

            <div class="btn-row">
                <button class="primary-btn" [disabled]="saving || !newCompany.name?.trim()" (click)="saveNewCompany()">
                    <i class="fa-solid" [class.fa-spinner]="saving" [class.fa-spin]="saving" [class.fa-check]="!saving"></i>
                    {{ saving ? 'Saving...' : 'Save Company' }}
                </button>
                <button class="cancel-btn" (click)="showNewCompany = false">Cancel</button>
            </div>

            <div class="alert alert--ok" *ngIf="newCompanyMessage">{{ newCompanyMessage }}</div>
            <div class="alert alert--err" *ngIf="newCompanyError">{{ newCompanyError }}</div>
        </div>
    </div>
</div>

<app-prospect-modal></app-prospect-modal>
<app-contact-modal></app-contact-modal>
